/*
 * Public API Surface of ngx-lib/textarea
 */
export * from './textarea.module';
export * from './textarea.component';
